export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        {/* Image */}
        <div className="rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20product%20collage%20of%20sneakers%20caps%20bags%20and%20accessories%20flatlay%20on%20warm%20cream%20textured%20paper%20background%20minimal%20clean%20aesthetic%20soft%20natural%20light%20editorial%20photography%20with%20subtle%20film%20grain%20texture%20harmonious%20neutral%20color%20palette&width=1200&height=600&seq=cta-gtbuy-collage-2026&orientation=landscape"
            alt="GTBuy Sheet collection of products"
            title="GTBuy Sheet Product Collection"
            className="w-full h-64 md:h-80 object-cover object-top"
          />
        </div>

        {/* Text */}
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
          Ready to <span className="italic text-foreground-400 font-normal">level up</span> your shopping?
        </h2>
        <p className="mt-2 text-lg md:text-xl text-foreground-500 font-light">
          Access the <strong className="font-semibold text-foreground-800">full spreadsheet</strong> with all 14 categories now.
        </p>

        {/* CTA Button */}
        <div className="mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-block px-10 py-4 rounded-full text-base md:text-lg font-semibold bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}